<template>
  <main>
    <vue-headful
      title="アシスタント募集 - ADLCJ リヨン補習授業校"
      description="リヨン補習授業校では現在、幼稚部・小中学部の授業のサポートをして下さるボランティアアシスタントを募集しています。"
      url="https://adlcj.fr/recrutement"
      site_name="ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises"
      type="article"
    />

    <section class="title">
      <div class="title-wrapper">
        <h1>アシスタント募集</h1>
      </div>
      <p>
        リヨン補習授業校では現在、幼稚部・小中学部の授業のサポートをして下さるボランティアアシスタントを募集しています。
      </p>
    </section>

    <div class="recruitWrap">
      <div class="recruitGrid">
        <div class="section-wrapper">
          <h2>業務内容</h2>
          <p>【幼稚部・小中学部共通】</p>
          <p>授業全般のサポート（プリント添削・工作等のサポート、学習指導サポート）</p>
          <p>
            【幼稚部・小学部低学年】 </p>
<p>安全面のサポート（トイレ・移動時の付き添い等）、 休憩時のサポート（おやつ時の準備・片付けの介助等）。
          </p>
        </div>

        <div class="section-wrapper">
          <h2>授業時間</h2>
          <p>小学部・幼稚部 : 土曜日の午前からお昼過ぎまで。
(校舎によって時間が異なるため詳細はご応募いただいた際にお知らせします。いずれの時間帯も授業は２時間半です。)</p>
        </div>

        <div class="section-wrapper">
          <h2>教室</h2>
          <p>Villeurbanne市</p>
        </div>

        <div class="section-wrapper">
          <h2>交通費</h2>
          <p>TCLチケット支給</p>
        </div>

        <div class="section-wrapper">
          <h2>期間</h2>
          <p>
            今年度は2027年7月3日まで。毎週もしくは隔週お越しいただける方が望ましいですがご都合の良い週のみ、または上記期間中の一部でも結構ですのでご遠慮なくお問い合わせください。
          </p>
        </div>
        <div class="section-wrapper">
          <h2>学校について</h2>
          <p>補習授業校は海外に住む日本人子女に国語を教える学校です。</p>
          <p>児童教育にご興味のある方や子供が好きな方、大歓迎です。</p>
          <p>
            ご応募・お問い合わせは下記メールアドレスまでご連絡ください。 <br />
          <a href="mailto:lyonhoshuko@adlcj.fr" class="mailLink"
            >lyonhoshuko@adlcj.fr</a
          >
          </p>
          
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Recrutement",
};
</script>

<style lang="scss" scoped>
.recruitWrap {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 0 60px;
  text-align: left;
}

.recruitGrid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-wrapper h2 {
  border: none;
  background-image: none;
  padding: 0;
  font-size: 1.25rem;

  @media (max-width: 767px) {
    font-size: 1rem;
  }
}

.section-wrapper p {
  font-size: 20px;

  @media (max-width: 767px) {
    font-size: 0.85rem;
  }
}

.mailLink {
  display: inline-block;
  margin-top: 0.5rem;
  font-weight: 600;
  font-size: 1.25rem;
  word-break: break-all;
  color: $linkColor;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 767px) {
    font-size: 1rem;
  }
}
</style>
